import http from '@/utils/http';
const base_path = '/v2/tool/byteDanceGame';

/**
 * 获取字节小游戏列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getByteDanceGameApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 同步字节小游戏接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const pullByteDanceGameApi = (params) => {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
};
